import React from 'react';
import { UnifyHandoff } from '../edit-handoff/unify-handoff/unify-handoff';

type Props = {
  groupId: string;
};

export const UnifySnapshotView = ({ groupId }: Props) => {
  return <UnifyHandoff handoffGroupId={groupId} mode="snapshot" initialStep="snapshot" />;
};
